export default "__VITE_ASSET__D52tOwew__"